'use client'

import * as React from 'react'
import { LazyMotion, domAnimation, m, useInView, useReducedMotion } from 'framer-motion'
import { EASE } from '@/lib/motion'
import { cn } from '@/lib/utils'

// The .rd-underline lime-highlighter idiom (see redesign-theme.css) as a
// self-contained leaf, so it can sit on any hero heading, not only inside
// .rd-hero. The bar sweeps in once (scaleX from the left) when the heading
// scrolls into view; reduced motion shows it fully drawn. One per page, max.

export function LimeUnderline({ children, className }: { children: React.ReactNode; className?: string }) {
  const ref = React.useRef<HTMLSpanElement>(null)
  const inView = useInView(ref, { once: true, margin: '0px 0px -10% 0px' })
  const reduce = useReducedMotion()

  return (
    <LazyMotion features={domAnimation}>
      <span ref={ref} className={cn('relative inline-block isolate', className)}>
        <span className="relative z-10">{children}</span>
        <m.span
          aria-hidden
          className="absolute bottom-[6%] left-0 right-[-2%] z-0 h-[0.28em] -skew-x-6 rounded-[3px] bg-brand-lime"
          style={{ originX: 0 }}
          initial={reduce ? false : { scaleX: 0 }}
          animate={inView ? { scaleX: 1 } : undefined}
          transition={{ duration: 0.5, ease: EASE, delay: reduce ? 0 : 0.3 }}
        />
      </span>
    </LazyMotion>
  )
}
